module.exports = __webpack_public_path__ + "static/media/icon_thinktool_W.70fd001e.svg";